import { render } from "./slider-list-page.vue?vue&type=template&id=f9697bf6"
import script from "./slider-list-page.vue?vue&type=script&lang=js"
export * from "./slider-list-page.vue?vue&type=script&lang=js"

import "./slider-list-page.vue?vue&type=style&index=0&id=f9697bf6&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__